import {
    lookupOne,
    lookupOneCached
} from "../../utils/elements.js";
import {
    gameObserver
} from "../../constants/observers.js";

lookupOne("#reset-height").addEventListener("click", () => {
    lookupOneCached(".js--pad").style.height = "";
});

lookupOne("#clear-grimoire").addEventListener("click", ({ target }) => {

    if (window.confirm(target.dataset.confirm)) {
        gameObserver.trigger("clear");
    }

});
